// components/Trainings.jsx
import axios from "axios";
import React, { useEffect, useState } from "react";

// Material Type enum
const MaterialType = {
  Behavior: "Behavior",
  Skill: "Skill",
  Knowledge: "Knowledge",
};

const Trainings = () => {
  const [isAddingTraining, setIsAddingTraining] = useState(false);
  const [isEditingTraining, setIsEditingTraining] = useState(false);
  const [isAddingMaterial, setIsAddingMaterial] = useState(false);
  const [editingTraining, setEditingTraining] = useState(null);
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [isSubmittingMatrial, setIsSubmittingMatrial] = useState(false);

  const [trainingFormData, setTrainingFormData] = useState({
    title: "",
    title_ar: "",
    description: "",
    description_ar: "",
    manual: null,
  });

  const [materialFormData, setMaterialFormData] = useState({
    training_id: "",
    title: "",
    title_ar: "",
    type: MaterialType.Behavior,
    material: null,
  });

  const [manualPreview, setManualPreview] = useState(null);
  const [materialPreview, setMaterialPreview] = useState(null);
  const [manualFile, setManualFile] = useState(null);
  const [trainings, setTrainings] = useState([
    {
      id: 1,
      title: "Leadership Development Program",
      description:
        "Comprehensive leadership training focusing on modern management techniques and team building strategies.",
      manual: "/api/placeholder/manual.pdf",
      manualType: "pdf",
      createdAt: "2024-01-15",
      materials: [
        {
          id: 1,
          title: "Communication Skills",
          type: MaterialType.Skill,
          file: "/api/placeholder/material.pdf",
          fileType: "pdf",
        },
        {
          id: 2,
          title: "Team Management",
          type: MaterialType.Behavior,
          file: "/api/placeholder/material.docx",
          fileType: "docx",
        },
      ],
    },
    {
      id: 2,
      title: "Technical Skills Workshop",
      description:
        "Hands-on technical training covering the latest tools and technologies in software development.",
      manual: "/api/placeholder/manual.docx",
      manualType: "docx",
      createdAt: "2024-01-10",
      materials: [
        {
          id: 3,
          title: "Advanced JavaScript",
          type: MaterialType.Knowledge,
          file: "/api/placeholder/material.pdf",
          fileType: "pdf",
        },
      ],
    },
  ]);
  const [flag, setFlag] = useState(false);

  const [isMaterialsModalOpen, setIsMaterialsModalOpen] = useState(false);

  // Function to open materials modal
  const openMaterialsModal = (training) => {
    setSelectedTraining(training);
    setIsMaterialsModalOpen(true);
  };

  // Function to close materials modal
  const closeMaterialsModal = () => {
    setSelectedTraining(null);
    setIsMaterialsModalOpen(false);
  };

  // Training CRUD Operations
  const handleTrainingSubmit = async (e) => {
    e.preventDefault();

    if (isEditingTraining && editingTraining) {
      // Update existing training
      const formDataRequest = new FormData();
      formDataRequest.append("training_id", editingTraining.id);
      formDataRequest.append("title", trainingFormData.title);
      formDataRequest.append("title_ar", trainingFormData.title_ar);
      formDataRequest.append("description", trainingFormData.description);
      formDataRequest.append("description_ar", trainingFormData.description_ar);
      if (manualFile) {
        formDataRequest.append("manual", manualFile);
        formDataRequest.append("manualType", manualFile.name.split(".").pop());
      }
      await axios.patch(
        process.env.REACT_APP_BASE_URL + "training/update-training",
        formDataRequest
      );
      setFlag(!flag);
    } else {
      // Add new training
      const formDataRequest = new FormData();
      formDataRequest.append("title", trainingFormData.title);
      formDataRequest.append("title_ar", trainingFormData.title_ar);
      formDataRequest.append("description", trainingFormData.description);
      formDataRequest.append("description_ar", trainingFormData.description_ar);
      formDataRequest.append("manual", trainingFormData.manual);
      formDataRequest.append(
        "manualType",
        trainingFormData.manual
          ? trainingFormData.manual.name.split(".").pop()
          : "pdf"
      );

      await axios.post(
        process.env.REACT_APP_BASE_URL + "training/add-training",
        formDataRequest
      );
      setFlag(!flag);
    }

    resetTrainingForm();
  };

  const handleEditTraining = (training) => {
    setTrainingFormData({
      title: training.title,
      title_ar: training.title_ar,
      description: training.description,
      description_ar: training.description_ar,
      manual: null,
    });
    setManualPreview(training.manual);
    setEditingTraining(training);
    setIsEditingTraining(true);
    setIsAddingTraining(true);
  };

  const handleDeleteTraining = async (trainingId) => {
    await axios.delete(
      process.env.REACT_APP_BASE_URL + "training/delete-training",
      {
        params: {
          training_id: trainingId,
        },
      }
    );
    setFlag(!flag);
  };

  const resetTrainingForm = () => {
    setTrainingFormData({ title: "", description: "", manual: null });
    setManualPreview(null);
    setIsAddingTraining(false);
    setIsEditingTraining(false);
    setEditingTraining(null);
  };

  // Material CRUD Operations
  // const handleMaterialSubmit = async (e) => {
  //   e.preventDefault();
  //   const formDataRequest = new FormData();
  //   formDataRequest.append(
  //     "training_id",
  //     parseInt(materialFormData.training_id)
  //   );
  //   formDataRequest.append("title", materialFormData.title);
  //   formDataRequest.append("title_ar", materialFormData.title_ar);
  //   formDataRequest.append("type", materialFormData.type);
  //   formDataRequest.append("file", materialFormData.material);
  //   formDataRequest.append(
  //     "fileType",
  //     materialFormData.material
  //       ? materialFormData.material.name.split(".").pop()
  //       : "pdf"
  //   );

  //   await axios.post(
  //     process.env.REACT_APP_BASE_URL + "training/add-training-matrial",
  //     formDataRequest
  //   );
  //   setFlag(!flag);
  //   resetMaterialForm();
  // };

  const handleMaterialSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsSubmittingMatrial(true); // Start loading

      const formDataRequest = new FormData();
      formDataRequest.append(
        "training_id",
        parseInt(materialFormData.training_id)
      );
      formDataRequest.append("title", materialFormData.title);
      formDataRequest.append("title_ar", materialFormData.title_ar);
      formDataRequest.append("type", materialFormData.type);
      formDataRequest.append("file", materialFormData.material);
      formDataRequest.append(
        "fileType",
        materialFormData.material
          ? materialFormData.material.name.split(".").pop()
          : "pdf"
      );

      await axios.post(
        process.env.REACT_APP_BASE_URL + "training/add-training-matrial",
        formDataRequest
      );

      setFlag(!flag);
      resetMaterialForm();
    } catch (error) {
      console.error("Error uploading material:", error);
      // Optional: Add error handling/notification here
    } finally {
      setIsSubmittingMatrial(false); // Stop loading
    }
  };

  const handleDeleteMaterial = async (trainingId, materialId) => {
    await axios.delete(
      process.env.REACT_APP_BASE_URL + "training/delete-training-matrial",
      {
        params: {
          training_matrial_id: materialId,
        },
      }
    );
    setFlag(!flag);
  };

  const resetMaterialForm = () => {
    setMaterialFormData({
      training_id: "",
      title: "",
      type: MaterialType.Behavior,
      material: null,
    });
    setMaterialPreview(null);
    setIsAddingMaterial(false);
    setSelectedTraining(null);
  };

  // Form Handlers
  const handleTrainingChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "manual" && files.length > 0) {
      const file = files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (fileExtension !== "pdf" && fileExtension !== "docx") {
        alert("Please upload only PDF or DOCX files");
        return;
      }

      if (isEditingTraining) {
        setManualFile(file);
      } else {
        setTrainingFormData({
          ...trainingFormData,
          manual: file,
        });
      }

      setManualPreview(URL.createObjectURL(file));
    } else {
      setTrainingFormData({
        ...trainingFormData,
        [name]: value,
      });
    }
  };

  const handleMaterialChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "material" && files.length > 0) {
      const file = files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      //   if (fileExtension !== "pdf" && fileExtension !== "docx") {
      //     alert("Please upload only PDF or DOCX files");
      //     return;
      //   }

      setMaterialFormData({
        ...materialFormData,
        material: file,
      });

      setMaterialPreview(URL.createObjectURL(file));
    } else {
      setMaterialFormData({
        ...materialFormData,
        [name]: value,
      });
    }
  };

  const openAddMaterial = (training) => {
    setSelectedTraining(training);
    setMaterialFormData({
      ...materialFormData,
      training_id: training.id.toString(),
    });
    setIsAddingMaterial(true);
  };

  // Helper Functions
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getFileIcon = (fileType) => {
    return fileType === "pdf" ? "📄" : "📝";
  };

  const getMaterialTypeColor = (type) => {
    switch (type) {
      case MaterialType.Behavior:
        return "from-green-500 to-green-600";
      case MaterialType.Skill:
        return "from-blue-500 to-blue-600";
      case MaterialType.Knowledge:
        return "from-purple-500 to-purple-600";
      default:
        return "from-green-500 to-green-600";
    }
  };

  const getMaterialTypeBadge = (type) => {
    switch (type) {
      case MaterialType.Behavior:
        return { color: "bg-green-100 text-green-800", text: "Behavior" };
      case MaterialType.Skill:
        return { color: "bg-blue-100 text-blue-800", text: "Skill" };
      case MaterialType.Knowledge:
        return { color: "bg-purple-100 text-purple-800", text: "Knowledge" };
      default:
        return { color: "bg-green-100 text-green-800", text: "Behavior" };
    }
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BASE_URL + "training/get-all-trainings")
      .then((res) => setTrainings(res.data.data));
  }, [flag]);

  return (
    <div className="space-y-8">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Total Trainings</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {trainings.length}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">🎯</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Total Materials</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {trainings.reduce(
                  (sum, training) => sum + training.materials.length,
                  0
                )}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">📚</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Behavior Materials</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {trainings.reduce(
                  (sum, training) =>
                    sum +
                    training.materials.filter(
                      (m) => m.type === MaterialType.Behavior
                    ).length,
                  0
                )}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">👥</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Skill Materials</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {trainings.reduce(
                  (sum, training) =>
                    sum +
                    training.materials.filter(
                      (m) => m.type === MaterialType.Skill
                    ).length,
                  0
                )}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">⚡</span>
            </div>
          </div>
        </div>
      </div>

      {/* Header with Add Button */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            Training Programs
          </h2>
          <p className="text-gray-600 mt-1">
            Manage training programs and their materials
          </p>
        </div>
        <button
          onClick={() => setIsAddingTraining(true)}
          className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center space-x-2 group"
        >
          <span className="group-hover:scale-110 transition-transform duration-200">
            +
          </span>
          <span>Add Training</span>
        </button>
      </div>

      {/* Add/Edit Training Form Modal */}
      {isAddingTraining && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl transform animate-scale-in max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-green-200 bg-gradient-to-r from-green-50 to-green-100 rounded-t-2xl">
              <h3 className="text-xl font-bold text-gray-800">
                {isEditingTraining ? "Edit Training" : "Add New Training"}
              </h3>
              <p className="text-green-600 text-sm mt-1">
                {isEditingTraining
                  ? "Update the training details"
                  : "Create a new training program"}
              </p>
            </div>
            <form onSubmit={handleTrainingSubmit} className="p-6 space-y-6">
              {/* Manual Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Training Manual *
                </label>
                <div className="flex items-center space-x-6">
                  <div className="w-32 h-40 bg-green-100 rounded-lg border-2 border-dashed border-green-300 flex items-center justify-center overflow-hidden">
                    {manualPreview ? (
                      <div className="text-center">
                        <span className="text-4xl text-green-600">
                          {trainingFormData.manual?.name?.endsWith(".pdf")
                            ? "📄"
                            : "📝"}
                        </span>
                        <p className="text-xs text-green-700 mt-2">
                          {trainingFormData.manual?.name}
                        </p>
                      </div>
                    ) : (
                      <span className="text-green-400 text-3xl">📄</span>
                    )}
                  </div>
                  <div className="flex-1">
                    <input
                      type="file"
                      name="manual"
                      accept=".pdf,.docx"
                      onChange={handleTrainingChange}
                      required={!isEditingTraining}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                    />
                    <p className="text-sm text-gray-500 mt-2">
                      Upload PDF or DOCX training manual (Max: 10MB)
                    </p>
                  </div>
                </div>
              </div>

              {/* Title Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Training Title *
                </label>
                <input
                  type="text"
                  name="title"
                  value={trainingFormData.title}
                  onChange={handleTrainingChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter training title"
                />
              </div>

              {/* Title_ar Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Training Title Arabic *
                </label>
                <input
                  type="text"
                  name="title_ar"
                  value={trainingFormData.title_ar}
                  onChange={handleTrainingChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter training title"
                />
              </div>

              {/* Description Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description *
                </label>
                <textarea
                  name="description"
                  value={trainingFormData.description}
                  onChange={handleTrainingChange}
                  required
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 resize-vertical"
                  placeholder="Enter training description"
                />
              </div>

              {/* Description_ar Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description Arabic *
                </label>
                <textarea
                  name="description_ar"
                  value={trainingFormData.description_ar}
                  onChange={handleTrainingChange}
                  required
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 resize-vertical"
                  placeholder="Enter training description"
                />
              </div>

              <div className="flex space-x-3 pt-4">
                <button
                  type="submit"
                  className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
                >
                  {isEditingTraining ? "Update Training" : "Add Training"}
                </button>
                <button
                  type="button"
                  onClick={resetTrainingForm}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-400 transition-colors duration-200"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Add Material Form Modal */}
      {isAddingMaterial && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl transform animate-scale-in max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-green-200 bg-gradient-to-r from-green-50 to-green-100 rounded-t-2xl">
              <h3 className="text-xl font-bold text-gray-800">
                Add Material to {selectedTraining?.title}
              </h3>
              <p className="text-green-600 text-sm mt-1">
                Upload training material for this program
              </p>
            </div>
            <form onSubmit={handleMaterialSubmit} className="p-6 space-y-6">
              {/* Material File Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Material File *
                </label>
                <div className="flex items-center space-x-6">
                  <div className="w-32 h-40 bg-green-100 rounded-lg border-2 border-dashed border-green-300 flex items-center justify-center overflow-hidden">
                    {materialPreview ? (
                      <div className="text-center">
                        <span className="text-4xl text-green-600">
                          {materialFormData.material?.name?.endsWith(".pdf")
                            ? "📄"
                            : "📝"}
                        </span>
                        <p className="text-xs text-green-700 mt-2">
                          {materialFormData.material?.name}
                        </p>
                      </div>
                    ) : (
                      <span className="text-green-400 text-3xl">📄</span>
                    )}
                  </div>
                  <div className="flex-1">
                    <input
                      type="file"
                      name="material"
                      accept=".pdf,.docx,.ppt,.pptx,.pps,.doc,.odp"
                      onChange={handleMaterialChange}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                    />
                    <p className="text-sm text-gray-500 mt-2">
                      Upload PDF or DOCX material file (Max: 10MB)
                    </p>
                  </div>
                </div>
              </div>

              {/* Title Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Material Title *
                </label>
                <input
                  type="text"
                  name="title"
                  value={materialFormData.title}
                  onChange={handleMaterialChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter material title"
                />
              </div>

              {/* Title Arabic Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Material Title Arabic *
                </label>
                <input
                  type="text"
                  name="title_ar"
                  value={materialFormData.title_ar}
                  onChange={handleMaterialChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter material title"
                />
              </div>

              {/* Type Selection */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Material Type *
                </label>
                <select
                  name="type"
                  value={materialFormData.type}
                  onChange={handleMaterialChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                >
                  <option value={MaterialType.Behavior}>Behavior</option>
                  <option value={MaterialType.Skill}>Skill</option>
                  <option value={MaterialType.Knowledge}>Knowledge</option>
                </select>
              </div>

              {/* <div className="flex space-x-3 pt-4">
                <button
                  type="submit"
                  className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
                >
                  Add Material
                </button>
                <button
                  type="button"
                  onClick={resetMaterialForm}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-400 transition-colors duration-200"
                >
                  Cancel
                </button>
              </div> */}
              <div className="flex space-x-3 pt-4">
                <button
                  type="submit"
                  disabled={isSubmittingMatrial}
                  className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:scale-100 flex items-center justify-center"
                >
                  {isSubmittingMatrial ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Uploading...
                    </>
                  ) : (
                    "Add Material"
                  )}
                </button>
                <button
                  type="button"
                  onClick={resetMaterialForm}
                  disabled={isSubmittingMatrial}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-400 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Trainings Grid */}
      {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {trainings.map((training, index) => (
          <div
            key={training.id}
            className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300 group animate-fade-in border border-green-100"
            style={{ animationDelay: `${index * 100}ms` }}
          >
            <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white relative">
              <div className="flex items-center justify-between">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <span className="text-2xl">🎯</span>
                </div>
                <div className="text-right">
                  <p className="text-2xl font-bold">
                    {training.materials.length}
                  </p>
                  <p className="text-sm opacity-90">Materials</p>
                </div>
              </div>
              <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1">
                <button
                  onClick={() => handleEditTraining(training)}
                  className="w-8 h-8 bg-white text-green-600 rounded-full flex items-center justify-center hover:bg-green-50 transition-colors duration-200 transform hover:scale-110 shadow-sm"
                  title="Edit Training"
                >
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </button>
                <button
                  onClick={() => handleDeleteTraining(training.id)}
                  className="w-8 h-8 bg-white text-red-600 rounded-full flex items-center justify-center hover:bg-red-50 transition-colors duration-200 transform hover:scale-110 shadow-sm"
                  title="Delete Training"
                >
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-green-700 transition-colors duration-200">
                {training.title}
              </h3>

              <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                {training.description}
              </p>

              <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                <span>Created {formatDate(training.createdAt)}</span>
                <span className="flex items-center space-x-1">
                  <span>{getFileIcon(training.manualType)}</span>
                  <span>Manual</span>
                </span>
              </div>

              <div className="mb-4">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-semibold text-gray-700">
                    Training Materials
                  </h4>
                  <button
                    onClick={() => openAddMaterial(training)}
                    className="text-green-600 hover:text-green-700 text-sm font-medium flex items-center space-x-1"
                  >
                    <span>+</span>
                    <span>Add Material</span>
                  </button>
                </div>

                {training.materials.length === 0 ? (
                  <div className="text-center py-4 text-gray-500 text-sm">
                    No materials added yet
                  </div>
                ) : (
                  <div className="space-y-2">
                    {training.materials.map((material) => {
                      const badge = getMaterialTypeBadge(material.type);
                      return (
                        <div
                          key={material.id}
                          className="flex items-center justify-between p-3 bg-gray-50 rounded-lg group/material"
                        >
                          <div className="flex items-center space-x-3">
                            <span className="text-lg">
                              {getFileIcon(material.fileType)}
                            </span>
                            <div>
                              <p className="font-medium text-sm text-gray-800">
                                {material.title}
                              </p>
                              <span
                                className={`px-2 py-1 rounded-full text-xs ${badge.color}`}
                              >
                                {badge.text}
                              </span>
                            </div>
                          </div>
                          <button
                            onClick={() =>
                              handleDeleteMaterial(training.id, material.id)
                            }
                            className="w-6 h-6 bg-red-100 text-red-600 rounded-full flex items-center justify-center hover:bg-red-200 transition-colors duration-200 opacity-0 group-hover/material:opacity-100"
                            title="Delete Material"
                          >
                            <svg
                              className="w-3 h-3"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="flex space-x-2">
                <button className="flex-1 bg-green-50 text-green-600 py-2 px-3 rounded-lg font-medium hover:bg-green-100 transition-colors duration-200 text-sm">
                  View Manual
                </button>
                <button className="flex-1 bg-blue-50 text-blue-600 py-2 px-3 rounded-lg font-medium hover:bg-blue-100 transition-colors duration-200 text-sm">
                  Download All
                </button>
              </div>
            </div>
          </div>
        ))}
        <div
          className="border-2 border-dashed border-green-300 rounded-2xl p-8 text-center hover:border-green-500 hover:bg-green-50 transition-all duration-300 cursor-pointer group min-h-[400px] flex items-center justify-center"
          onClick={() => setIsAddingTraining(true)}
        >
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-200 transition-colors duration-200">
            <span className="text-2xl text-green-600 group-hover:scale-110 transition-transform duration-200">
              +
            </span>
          </div>
          <h3 className="text-lg font-semibold text-gray-700 mb-2 group-hover:text-green-700 transition-colors duration-200">
            Add New Training
          </h3>
          <p className="text-gray-500 text-sm group-hover:text-gray-600 transition-colors duration-200">
            Create a new training program with materials
          </p>
        </div>
      </div> */}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {trainings.map((training, index) => (
          <div
            key={training.id}
            className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300 group animate-fade-in border border-green-100"
            style={{ animationDelay: `${index * 100}ms` }}
          >
            {/* Training Header */}
            <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white relative">
              <div className="flex items-center justify-between">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <span className="text-2xl">🎯</span>
                </div>
                <div className="text-right">
                  <p className="text-2xl font-bold">
                    {training.materials.length}
                  </p>
                  <p className="text-sm opacity-90">Materials</p>
                </div>
              </div>
              <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1">
                <button
                  onClick={() => handleEditTraining(training)}
                  className="w-8 h-8 bg-white text-green-600 rounded-full flex items-center justify-center hover:bg-green-50 transition-colors duration-200 transform hover:scale-110 shadow-sm"
                  title="Edit Training"
                >
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </button>
                <button
                  onClick={() => handleDeleteTraining(training.id)}
                  className="w-8 h-8 bg-white text-red-600 rounded-full flex items-center justify-center hover:bg-red-50 transition-colors duration-200 transform hover:scale-110 shadow-sm"
                  title="Delete Training"
                >
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Training Details */}
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-green-700 transition-colors duration-200">
                {training.title}
              </h3>

              <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                {training.description}
              </p>

              <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                <span>Created {formatDate(training.createdAt)}</span>
                <span className="flex items-center space-x-1">
                  <span>{getFileIcon(training.manualType)}</span>
                  <span>Manual</span>
                </span>
              </div>

              {/* Materials Section - Minimal Preview */}
              <div className="mb-6">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-semibold text-gray-700">
                    Materials ({training.materials.length})
                  </h4>
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() => openAddMaterial(training)}
                      className="text-green-600 hover:text-green-700 text-sm font-medium flex items-center space-x-1"
                    >
                      <span>+</span>
                      <span>Add</span>
                    </button>
                    {training.materials.length > 0 && (
                      <button
                        onClick={() => openMaterialsModal(training)}
                        className="text-blue-600 hover:text-blue-700 text-sm font-medium flex items-center space-x-1"
                      >
                        <span>View All</span>
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>

                {training.materials.length === 0 ? (
                  <div className="text-center py-2 text-gray-500 text-sm">
                    No materials added yet
                  </div>
                ) : (
                  <div className="flex flex-wrap gap-2">
                    {training.materials.slice(0, 4).map((material) => {
                      const badge = getMaterialTypeBadge(material.type);
                      return (
                        <div
                          key={material.id}
                          className="px-3 py-2 bg-gray-50 rounded-lg flex items-center space-x-2 max-w-full"
                          title={material.title}
                        >
                          <span className="text-lg">
                            {getFileIcon(material.fileType)}
                          </span>
                          <div className="min-w-0">
                            <p className="font-medium text-sm text-gray-800 truncate max-w-[120px]">
                              {material.title}
                            </p>
                            <span
                              className={`px-1 py-0.5 rounded-full text-xs ${badge.color}`}
                            >
                              {badge.text}
                            </span>
                          </div>
                        </div>
                      );
                    })}

                    {training.materials.length > 4 && (
                      <button
                        onClick={() => openMaterialsModal(training)}
                        className="px-3 py-2 bg-blue-50 text-blue-600 rounded-lg text-sm font-medium hover:bg-blue-100 transition-colors"
                      >
                        +{training.materials.length - 4} more
                      </button>
                    )}
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div className="flex space-x-2">
                <button className="flex-1 bg-green-50 text-green-600 py-2 px-3 rounded-lg font-medium hover:bg-green-100 transition-colors duration-200 text-sm">
                  View Manual
                </button>
                <button className="flex-1 bg-blue-50 text-blue-600 py-2 px-3 rounded-lg font-medium hover:bg-blue-100 transition-colors duration-200 text-sm">
                  Download All
                </button>
              </div>
            </div>
          </div>
        ))}

        {/* Add New Training Card */}
        <div
          className="border-2 border-dashed border-green-300 rounded-2xl p-8 text-center hover:border-green-500 hover:bg-green-50 transition-all duration-300 cursor-pointer group min-h-[400px] flex-column items-center justify-center"
          onClick={() => setIsAddingTraining(true)}
        >
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-200 transition-colors duration-200">
            <span className="text-2xl text-green-600 group-hover:scale-110 transition-transform duration-200">
              +
            </span>
          </div>
          <h3 className="text-lg font-semibold text-gray-700 mb-2 group-hover:text-green-700 transition-colors duration-200">
            Add New Training
          </h3>
          <p className="text-gray-500 text-sm group-hover:text-gray-600 transition-colors duration-200">
            Create a new training program with materials
          </p>
        </div>
      </div>

      {/* Materials Modal */}
      {isMaterialsModalOpen && selectedTraining && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
              <div className="flex justify-between items-center">
                <h3 className="text-2xl font-bold">
                  {selectedTraining.title} - Materials
                </h3>
                <button
                  onClick={closeMaterialsModal}
                  className="text-white hover:text-green-200 text-2xl font-bold transition-colors"
                >
                  ×
                </button>
              </div>
              <p className="text-green-100 mt-2">
                Total Materials: {selectedTraining.materials.length}
              </p>
            </div>

            {/* Modal Content */}
            <div className="p-6 max-h-[60vh] overflow-y-auto">
              {selectedTraining.materials.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  No materials available
                </div>
              ) : (
                <div className="space-y-3">
                  {selectedTraining.materials.map((material) => {
                    const badge = getMaterialTypeBadge(material.type);
                    return (
                      <div
                        key={material.id}
                        className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                      >
                        <div className="flex items-center space-x-4">
                          <span className="text-2xl text-green-600">
                            {getFileIcon(material.fileType)}
                          </span>
                          <div>
                            <h4 className="font-semibold text-gray-800">
                              {material.title}
                            </h4>
                            <div className="flex items-center space-x-3 mt-1">
                              <span
                                className={`px-2 py-1 rounded-full text-xs ${badge.color}`}
                              >
                                {badge.text}
                              </span>
                              <span className="text-xs text-gray-500">
                                {material.fileType}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => {
                              /* Handle download */
                            }}
                            className="text-green-600 hover:text-green-700"
                            title="Download"
                          >
                            <svg
                              className="w-5 h-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                              />
                            </svg>
                          </button>
                          <button
                            onClick={() =>
                              handleDeleteMaterial(
                                selectedTraining.id,
                                material.id
                              )
                            }
                            className="text-red-600 hover:text-red-700"
                            title="Delete"
                          >
                            <svg
                              className="w-5 h-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div className="border-t border-gray-200 p-4 bg-gray-50">
              <div className="flex justify-between items-center">
                <button
                  onClick={() => openAddMaterial(selectedTraining)}
                  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors font-semibold flex items-center space-x-2"
                >
                  <span>+</span>
                  <span>Add New Material</span>
                </button>
                <button
                  onClick={closeMaterialsModal}
                  className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg transition-colors font-semibold"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Empty State */}
      {trainings.length === 0 && (
        <div className="text-center py-16">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-4xl text-green-600">🎯</span>
          </div>
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            No training programs yet
          </h3>
          <p className="text-gray-500 mb-6 max-w-md mx-auto">
            Start building your training programs by creating your first
            training. You can add materials for each training program.
          </p>
          <button
            onClick={() => setIsAddingTraining(true)}
            className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
          >
            Create First Training
          </button>
        </div>
      )}

      {/* Quick Stats Footer */}
      {trainings.length > 0 && (
        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-6 text-white">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div>
              <p className="text-sm opacity-90">Total Trainings</p>
              <p className="text-2xl font-bold">{trainings.length}</p>
            </div>
            <div>
              <p className="text-sm opacity-90">Total Materials</p>
              <p className="text-2xl font-bold">
                {trainings.reduce(
                  (sum, training) => sum + training.materials.length,
                  0
                )}
              </p>
            </div>
            <div>
              <p className="text-sm opacity-90">Behavior</p>
              <p className="text-2xl font-bold">
                {trainings.reduce(
                  (sum, training) =>
                    sum +
                    training.materials.filter(
                      (m) => m.type === MaterialType.Behavior
                    ).length,
                  0
                )}
              </p>
            </div>
            <div>
              <p className="text-sm opacity-90">Skill</p>
              <p className="text-2xl font-bold">
                {trainings.reduce(
                  (sum, training) =>
                    sum +
                    training.materials.filter(
                      (m) => m.type === MaterialType.Skill
                    ).length,
                  0
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Trainings;
